import { WrappedOrder } from '@/entities/WrappedOrder';
import { useWrappedOrderListByUser } from '@/features/account/orderHook';
import { useFetchPortfolioListFromApi } from '@/features/portfolio/query';
import { useEffect } from 'react';
import { useChainId, useUserAddr } from '../web3/useChain';
export type UseOpenOrderListWithCreateTimeProps = Parameters<typeof useWrappedOrderListByUser>;
export default function useOpenOrderListWithCreateTime(orders: WrappedOrder[] | undefined): WrappedOrder[] | undefined {
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const { data, isFetching } = useFetchPortfolioListFromApi(chainId, userAddr);
  useEffect(() => {
    orders?.forEach((order) => {
      if (order) {
        const portfolio = data?.portfoliosFromApi?.find(
          (d) => d.instrumentAddr === order.instrumentAddr && d.expiry === order.expiry,
        );
        const selectedOrder = portfolio?.orders?.find((d) => d.oid === order.oid);
        if (selectedOrder) {
          order.setLastUpdateTime(selectedOrder.lastUpdateTime);
          order.setLastUpdateTxHash(selectedOrder.lastUpdateTxHash);
        }
      }
    });
  }, [data?.portfoliosFromApi, isFetching]);
  return orders;
}
